import React from 'react';
import EveRoutes from '../EveRoutes';

const EvePageNotFoundError = (): JSX.Element => {
  return (
    <>
      <h2>The requested page cannot be found.</h2>
      <p data-testid="not-found-error">
        Please check the address, try again, or <a href={EveRoutes.HOME}> go to the homepage </a>
      </p>
    </>
  );
};

export default EvePageNotFoundError;
